if (!jQuery) {
    console.log('jquery.popupoverlay - jQuery not defined.');
}
require('./jquery.popupoverlay');


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/WorkInEstonia-India/wp-content/themes/workinestonia/node_modules/jquery-popup-overlay/index.js
// module id = 69
// module chunks = 0